export default __webpack_public_path__ + "static/media/stone-guardian--front--240.eb072359.jpg";